/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipType
 */
export interface ShipType {
    /**
     * 
     * @type {number}
     * @memberof ShipType
     */
    mmsi?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipType
     */
    imo?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipType
     */
    callsign?: string;
    /**
     * Draught of the ship [m]
     * @type {number}
     * @memberof ShipType
     */
    draught?: number;
}

/**
 * Check if a given object implements the ShipType interface.
 */
export function instanceOfShipType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipTypeFromJSON(json: any): ShipType {
    return ShipTypeFromJSONTyped(json, false);
}

export function ShipTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
        'draught': !exists(json, 'draught') ? undefined : json['draught'],
    };
}

export function ShipTypeToJSON(value?: ShipType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
        'name': value.name,
        'callsign': value.callsign,
        'draught': value.draught,
    };
}

